import { createAsyncThunk } from "@reduxjs/toolkit";

import { promiseFetchDataAuth } from 'crk-front-lib';

const APIPATH = '/api/v2';

export const queryActiveOrder = createAsyncThunk('report/fetchActive', async (cond, thunkAPI) => {
  const url = `${APIPATH}/work-reports`;
  let _qry = '';

  if(cond.sub && cond.sub !== '') {
    _qry += ( _qry === '' ? '' : '&' ) + `sub=${cond.sub}`;
  }

  if(cond.filter && cond.filter !== '') {
    _qry += ( _qry === '' ? '' : '&' ) + `filter=` + encodeURIComponent(cond.filter);
  }

  if(cond.due && cond.due !== '') {
    _qry += ( _qry === '' ? '' : '&' ) + `due=${cond.due}`;
  }

  if(cond.status && cond.status !== '') {
    _qry += ( _qry === '' ? '' : '&' ) + `status=${cond.status}`;
  }

  const result = await promiseFetchDataAuth(url + (_qry === '' ? '' : `?${_qry}`));

  return result;
});

export const queryPlanDueOrder = createAsyncThunk('report/fetchPlanDue', async (cond, thunkAPI) => {
  const url = `${APIPATH}/work-reports`;
  let _qry = 'due=PLAN-6M';

  const result = await promiseFetchDataAuth(url + (_qry === '' ? '' : `?${_qry}`));

  return result;
});

export const changeStatus = createAsyncThunk('report/changeStatus', async (value, thunkAPI) => {
  // console.info(value);
  const url = `${APIPATH}/work-orders/${value._id}`;

  const result = await promiseFetchDataAuth(url, 'PATCH', value);

  return result;
})